<div class="container-fluid">
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <h1 class="title mb-0">{{ pageTitle }}</h1>
        </div>
      </div>
      <div class="row my-3 gy-sm-2 search-container">
        <div class="col-12">
          <form
            [formGroup]="prescriptionForm"
            (ngSubmit)="onSearchPrescription()"
          >
            <div class="form-group">
              <input
                formControlName="prescriptionText"
                class="prescriptionText form-control"
                type="text"
                name="prescriptionText"
                placeholder="Search By Patient Name or Mobile number"
              />
            </div>
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                id="prescription-duration"
                placeholder="Prescription Duration"
                bsDaterangepicker
                formControlName="prescriptionDuration"
                [bsConfig]="{
                  isAnimated: true,
                  containerClass: 'theme-blue'
                }"
                name="bsDaterangepicker"
              />
            </div>
            <div class="form-group form-actions">
              <button type="submit" class="btn btn-primary">Search</button>
            </div>
          </form>
        </div>
      </div>
      <div class="row">
        <div class="col-12 status-filter-btns">
          <h5 class="filter">Filter By</h5>
          <div class="filter-btn-container">
            <button
              *ngFor="let item of filterTypes"
              class="btn btn-filter"
              (click)="onBtnSearchPrescription(item.value, item.key)"
              [ngClass]="{ 'active-btn': prescriptionStatus == item.value }"
            >
              {{ item.key }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="row"
    *ngIf="!filteredPrescriptionArray?.length && !noMatchingResult"
  >
    <div class="col-12 text-center py-5">
      Hmm, There are no prescriptions to show! 🥳
    </div>
  </div>
  <div class="row" *ngIf="noMatchingResult">
    <div class="col-12 text-center py-5">
      Sorry, we could not find any matching requests! 🥳
    </div>
  </div>
  <div *ngIf="filteredPrescriptionArray.length" class="card">
    <div class="card-body">
      <div class="table-title d-flex justify-content-between">
        <div class="table-title-actions col-md-12">
            <div class="row justify-content-between align-items-center col-md-12">
              <h3 class="m-0">All Requests</h3>
              <button class="btn btn-neutral" (click)="exportTOExcel()">
                <span class="btn-inner--icon">
                  <i class="ni ni-cloud-download-95"> </i>
                </span>
                <span class="btn-inner--text"> Download as Excel </span>
              </button>
          </div>
        </div>
        <!-- <a (click)="invertSorting()">
          <span>↑</span>
          <span class="ml--1">↓</span>
          Sort By
        </a> -->
      </div>
      <div>
        <ngx-datatable class="material ngx-datatable-custom"
        [rows]="filteredPrescriptionArray"
        [columns]="columns"
        [limit]="pageSize"
        columnMode="force"
        externalPaging="true"
        [count]="totalItems"
        [scrollbarH]="true"
        (activate)="onActivate($event)"
        [headerHeight]="50"
        [footerHeight]="50"
        rowHeight="auto"
        (page)="onChangePage($event)">
      </ngx-datatable>
      </div>
    </div>
  </div>
</div>
